import { render, staticRenderFns } from "./workerEduContinue.vue?vue&type=template&id=0d65b4b8&scoped=true&"
import script from "./workerEduContinue.vue?vue&type=script&lang=js&"
export * from "./workerEduContinue.vue?vue&type=script&lang=js&"
import style0 from "./workerEduContinue.vue?vue&type=style&index=0&id=0d65b4b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65b4b8",
  null
  
)

export default component.exports